import React from 'react';
import { SercomTypes } from '../support/sercom-types';
import { Checkbox, FormControlLabel } from '@mui/material';

const SercomCheckbox = (props: SercomTypes.SercomCheckbox) => {
  return (
    <FormControlLabel
      name={props.name ?? ''}
      label={props.label}
      control={<Checkbox disabled={props.disabled ?? false} checked={props.checked} onChange={props.onChange} />}
    ></FormControlLabel>
  );
};

export default SercomCheckbox;

